<template>
	<div class="row" style="margin-right: 0 !important">
		<div class="col-12">
			<div class="row">
				<div class="col-4">
					<div class="logo">
						<img src="/images/FACE_3.png" id="logo" class="logo"/>
					</div>
				</div>
				<div class="col-8">
					<div class="toolbar">
						<div v-if="menu == 'FACTURACION' || menu == 'CLIENTES'" :class="menu == 'FACTURACION' ? 'toolbar-menu menu-activo' : 'toolbar-menu'" @click="accion('FACTURACION')">
							<div><img src="/images/actividades.png" class="toolbar-imagen"></div>
							<div class="texto-toolbar-menu">Actividades</div>
						</div>
						<div v-if="menu == 'FACTURACION' || menu == 'CLIENTES'" :class="menu == 'CLIENTES' ? 'toolbar-menu menu-activo' : 'toolbar-menu'" @click="accion('CLIENTES')">
							<div><img src="/images/clientes.png" class="toolbar-imagen"></div>
							<div class="texto-toolbar-menu">Clientes</div>
						</div>
						<div v-if="menu == 'REFACTURACION' || menu == 'REPORTE'" :class="menu == 'REFACTURACION' ? 'toolbar-menu menu-activo' : 'toolbar-menu'" @click="accion('REFACTURACION')">
							<div><img src="/images/actividades.png" class="toolbar-imagen"></div>
							<div class="texto-toolbar-menu">Actividades</div>
						</div>
						<div v-if="menu == 'REFACTURACION' || menu == 'REPORTE'" :class="menu == 'REPORTE' ? 'toolbar-menu menu-activo' : 'toolbar-menu'" @click="accion('REPORTE')">
							<div><img src="/images/reporte.png" class="toolbar-imagen"></div>
							<div class="texto-toolbar-menu">Reporte</div>
						</div>
						<div class="toolbar-menu" @click="finalizar()">
							<div><img src="/images/cerrar.png" style="width: 40px"></div>
							<div class="texto-toolbar-menu">Cerrar Sesión</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row barra">
				<div class="col-6">
					<div class="btn-volver"><a @click="volver()"><i class="fas fa-arrow-circle-left fa-fw fa-2x" /></a></div>
					<div class="titulo"><h3>{{ menu }}</h3></div>
				</div>
				<div class="col-6 text-right">
					<div style="display: inline-block">
						<div v-if="menu == 'FACTURACION'" class="periodo"><h5><b-badge variant="danger">Período: {{ getPeriodo }}</b-badge></h5></div>
						<div v-if="menu == 'FACTURACION'" class="calendario">
							<template>
								<b-form-datepicker
									button-only
									class="mb-1" 
									v-model="periodo"
									dropleft 
									locale="es"
									size="sm"
									@context="dateOnContext"
								></b-form-datepicker>
							</template>
						</div>
						<div v-if="menu == 'REFACTURACION'"><i class="fas fa-archive fa-fw fa-2x"></i></div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import Vue from 'vue'


	export default 
	{
		name: "Header",
		props: {
			menu: {
				Type: String,
				Default: "actividades"
			},
			onMenu: Function, // Funcion callback para la accion volver a la pantalla anterior
			onLogin: Function, // Funcion callback para finalizar la sesion
		},
		data() {
			return {
				periodo: "",
				tmenu: this.menu,
			}
		},
		created() {

			this.periodo = this.$periodo;
		},
		computed: {

			// Metodo que corta el día de la fecha (periodo) para mostrarlo en la pantalla con formato YYYY-MM
			getPeriodo() {

				return this.periodo.substr(0, 7)
			}
		},
		methods: {

			// Metodo que se activa cuando ocurre un cambio de fecha
			dateOnContext(ctx) {

				if (ctx.selectedYMD != "" && ctx.selectedYMD != this.$periodo)
				{
					// Variable global que guarda el periodo seleccionado
					Vue.prototype.$periodo = ctx.selectedYMD
					// Actualizamos la variable local para poder actualizar el calendario (?????)
					this.periodo = ctx.selectedYMD 

					// Emitimos el mensaje para avisar a todos los componentes que hubo cambio de periodo
					window.event.$emit("evento-cambio-periodo", ctx.selectedYMD)
				}
			},

			// Metodo que controla la accion de los botones de la toolbar
			accion(menu) {

				this.tmenu = menu
				if (this.onMenu)
					this.onMenu(menu)
			},

			// Metodo para finalizar la sesion. 
			// Envia un evento "evento-login" al padre quien finaliza la sesion y devuelve a la pantalla login
			finalizar() {

				if (this.onLogin)
					this.onLogin(false)
			},

			// Metodo para volver al menu principal
			// Envia el evento "evento-menu" al padre, para que este actualice la pantalla, mostrando el menu principal
			volver() {

				if (this.onMenu)
					this.onMenu("")
			},
		}
	}
</script>

<style scoped>

	.logo {
		margin-top: 6px;
		margin-left: 10px;
		width: 200px;
	}

	.toolbar {
		float: right;
		padding-top: 5px;
		/*padding-right: 10px;*/
	}

	.toolbar-menu {
		width: 95px; 
		float: left;
		padding: 5px 5px 3px 5px;
		text-align: center;
	}

	.toolbar-menu:hover {
		background-color: lightgray;
		border-radius: 4px 4px 0 0;
		cursor: pointer;
	}

	.texto-toolbar-menu {
		font-size: 13px;
	}

	.toolbar-imagen {
		width: 45px;
	}

	.menu-activo {
		font-weight: bold;
	}

	.barra {
		height: 50px;
		background-color: lightgray;
		padding: 5px 0px 5px 10px;
	}

	.btn-volver {
		float: left;
		margin-top: 4px;
		margin-right: 10px;
	}

	.btn-volver a {
		text-decoration: none;
		color: black;
	}

	.btn-volver a:hover {
		color: gray;
		cursor: pointer;
	}

	.titulo {
		float: left;
		margin-top: 3px;
		margin-left: 10px;
	}

	.periodo {
		float: left;
		margin-top: 7px;
		margin-right: 15px;
	}

	.calendario {
		padding-top: 4px;
		float: left;
	}

</style>
